import { createFileRoute } from '@tanstack/react-router'

import { PaymentsPage } from '#/modules/billing/payments-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/payments')({
  component: PaymentsPage,
  validateSearch: validateListSearch,
})
